import React, { useState, useEffect } from 'react';
import { Container, Table } from 'react-bootstrap';
import { FaCheckCircle, FaTimesCircle, FaQuestionCircle } from 'react-icons/fa';
import axios from 'axios';

const SystemHealth = () => {
    const [healthStatus, setHealthStatus] = useState([]);
    const [loading, setLoading] = useState(true);

    const bpsUrls = [
        {
            url: 'https://scp.bps.gub.uy/my.policy',
            service: 'BPS Login'
        },
        {
            url: 'https://scp.bps.gub.uy/PortalServLineaWeb/inicio',
            service: 'BPS Portal'
        },
        {
            url: 'https://scp.bps.gub.uy/AfiliacionesAfapWeb/paginas/jubilacionesAFAP/consultas/consultaSolicitudJubilacion/ConsultaSolicitudJubilacionHome.faces',
            service: 'BPS Jubilaciones'
        },
        {
            url: 'https://scp.bps.gub.uy/AfiliacionesAfapWeb/paginas/traspasosAFAP/mantenimiento/TraspasoAFAPHome.faces',
            service: 'BPS Traspasos'
        },
        {
            url: 'https://dgrec.gub.uy/partidasdigitales/publico/home.xhtml',
            service: 'Registro Civil'
        },
        {
            url: 'https://serviciospublicos.bse.com.uy/AplicacionAccesoPublico/index.jsp',
            service: 'BSE'
        }
    ];

    const checkUrl = async (url, service) => {
        const startTime = Date.now();
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/systemhealth/check`, {
                params: { url },
                timeout: 10000
            });
            
            return {
                url,
                service,
                isOnline: response.data.isOnline,
                responseTimeMs: response.data.responseTimeMs,
                description: response.data.description
            };
        } catch (error) {
            return {
                url,
                service,
                isOnline: false,
                responseTimeMs: 0,
                description: error.message
            };
        }
    };

    const checkAllUrls = async () => {
        setLoading(true);
        try {
            const results = await Promise.all(
                bpsUrls.map(({ url, service }) => checkUrl(url, service))
            );
            setHealthStatus(results);
        } catch (error) {
            console.error('Error checking URLs:', error);
        }
        setLoading(false);
    };

    useEffect(() => {
        checkAllUrls();
        const interval = setInterval(checkAllUrls, 60000); // Check every minute
        return () => clearInterval(interval);
    }, []);

    const getStatusIcon = (isOnline) => {
        if (isOnline === true) return <FaCheckCircle style={{ color: '#28a745', fontSize: '1.2rem' }} />;
        if (isOnline === false) return <FaTimesCircle style={{ color: '#dc3545', fontSize: '1.2rem' }} />;
        return <FaQuestionCircle style={{ color: '#ffc107', fontSize: '1.2rem' }} />;
    };

    const getResponseTimeStyle = (responseTime) => {
        if (responseTime < 1000) return { color: '#28a745' };
        if (responseTime < 3000) return { color: '#ffc107' };
        return { color: '#dc3545' };
    };
    return (
        <Container className="mt-5">
            <h2 className="mb-5">Estado de Servicios BPS</h2>
            <Table 
                striped 
                bordered 
                hover 
                responsive
                style={{
                    border: '2px solid #dee2e6',
                    borderCollapse: 'separate',
                    borderSpacing: '0',
                }}
            >
                <thead>
                    <tr>
                        <th className="p-4" style={{borderBottom: '2px solid #dee2e6'}}>Servicio</th>
                        <th className="p-4" style={{borderBottom: '2px solid #dee2e6'}}>Estado</th>
                        <th className="p-4" style={{borderBottom: '2px solid #dee2e6'}}>URL</th>
                        <th className="p-4" style={{borderBottom: '2px solid #dee2e6'}}>Tiempo de Respuesta</th>
                        <th className="p-4" style={{borderBottom: '2px solid #dee2e6'}}>Descripción</th>
                    </tr>
                </thead>
                <tbody>
                    {healthStatus.map((status, index) => (
                        <tr key={index} style={{height: '60px'}}>
                            <td className="p-4"><strong>{status.service}</strong></td>
                            <td className="text-center p-4">{getStatusIcon(status.isOnline)}</td>
                            <td className="p-4"><small>{status.url}</small></td>
                            <td className="p-4" style={getResponseTimeStyle(status.responseTimeMs)}>
                                {status.responseTimeMs}ms
                            </td>
                            <td className="p-4">{status.description}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </Container>
    );
};

export default SystemHealth;